const initialState = {
  appName: '',
  appVersion: '',
  firebase: null,
  // sentryUrl: '',
};

const reducer = (
  state = initialState,
) => state;

export default reducer;



// WEBPACK FOOTER //
// ./src/common/config/reducer.js